import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { Agent, Agents } from '../interfaces/agent';
import { BASEURL } from '../constant/url';

@Injectable({
  providedIn: 'root',
})
export class AgentService {
  private readonly _http = inject(HttpClient);

  fetchAgents(page: number, pageSize?: number, query?: string): Observable<Agents> {
    let url = `${BASEURL}agents?sort=id:desc&pagination[page]=${page}&pagination[pageSize]=${pageSize || 10}`;
    if (query) {
      url += `&filters[$or][0][name][$containsi]=${encodeURIComponent(query)}&filters[$or][1][email][$containsi]=${encodeURIComponent(query)}`;
    }
    return this._http.get<Agents>(url).pipe(catchError(this.handleError));
  }

  fetchAgent(id: number): Observable<Agent> {
    return this._http
      .get<Agent>(
        BASEURL +
        `agents/${id}?populate[contact_people]=*&populate[notes][populate]=users_permissions_user`
      )
      .pipe(
        map((response: Agent) => response.data),
        catchError(this.handleError)
      );
  }

  addAgent(data: any): Observable<Agent> {
    return this._http.post<Agent>(BASEURL + 'agents', { data }).pipe(catchError(this.handleError));
  }

  updateAgent(id: number, data: any): Observable<Agent> {
    return this._http.put<Agent>(BASEURL + `agents/${id}`, { data }).pipe(catchError(this.handleError));
  }

  deleteAgent(id: number): Observable<Agent> {
    return this._http.delete<Agent>(BASEURL + `agents/${id}`).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Error en el servicio de Agentes.';
    if (error.error && error.error.error && error.error.error.message) {
      errorMessage = error.error.error.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    console.error('AgentService error:', errorMessage, error.error || error);
    return throwError(() => new Error(errorMessage));
  }
}
